<template>
  <form-gift-card
    v-if="product"
    ref="formRef"
    v-model:attribute-selection="attributeSelection"
    :attribute-selection-labels="attributeSelectionLabels"
    :error
    :handle-next-attribute="handleNextAttribute"
    :pending="productPending || addToCartLoading"
    :product
    :show-only-first-selector-on-mobile="showOnlyFirstSelectorOnMobile"
    @select-card-amount="selectSize"
    @select-card-style="selectColor"
    @submit="handleAddToCart"
  >
    <slot />
  </form-gift-card>
</template>

<script lang="ts" setup>
import type { FormGiftCard as FormGiftCardType } from '#components'
import type { GiftOption } from '#types/cart'

defineProps<{ showOnlyFirstSelectorOnMobile?: boolean }>()

const {
  addToCart,
  addToCartLoading,
  attributeSelection,
  attributeSelectionLabels,
  error,
  handleNextAttribute,
  product,
  productPending,
  selectColor,
  selectSize,
  selectedVariant
} = usePdp()

const formRef = ref<InstanceType<typeof FormGiftCardType>>()

const handleAddToCart = ({
  giftOption,
  customAmount
}: {
  giftOption: GiftOption
  customAmount?: { amount?: number }
}) => {
  if (!formRef.value?.validate(true)) return

  addToCart({
    product: selectedVariant.value?.id,
    ...(giftOption ? { giftOption } : {}),
    ...(customAmount ? { customAmount } : {}),
    handleValidation: false
  })
}
</script>
